import * as React from 'react'
import { asField } from 'informedv1'
import Select from 'react-select';

export const MultiSelect = asField(({ fieldState, fieldApi, ...props }) => {
    const { value } = fieldState;
    const { setValue, setTouched } = fieldApi;
    const { onChange, onBlur, initialValue, forwardedRef, options, ...rest } = props;

    return <>
        <Select
            {...rest}
            classNamePrefix="multiSelect"
            options={options}
            ref={forwardedRef}
            value={!value ? initialValue : value.map(v => options.find(o => o.Id === v))}
            getOptionLabel={v => v[props.labelKey]}
            getOptionValue={v => v[props.valueKey]}
            onChange={(e) => {
                //A multiselect passes an array when it changes, but it can be empty.
                //An empty array is considered a null value
                e && e.length > 0 ? setValue(e.map(option => option[props.valueKey])) : setValue(null);
                if (onChange)
                    onChange();
            }}
            onBlur={e => {
                setTouched()
                if (onBlur) {
                    onBlur(e);
                }
            }}
            isMulti
        />
        {fieldState.error ? (
            <span style={{ color: 'red' }}>{fieldState.error}</span>
        ) : null}
        {fieldState.asyncError ? (
            <span style={{ color: 'red' }}>{fieldState.asyncError}</span>
        ) : null}
    </>
});
